/* eslint-disable no-unused-vars */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Progress,
} from 'reactstrap';

// import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// import { get } from '../../helpers/api_helper';

function PodProgressBar(props) {
  const {
    t, goal, progress, expected, label,
  } = props;

  const progressPercent = Math.round((progress / goal) * 100);
  const expectedPercent = Math.round((expected / goal) * 100);
  const gapPercent = Math.max(0, expectedPercent - progressPercent);

  const jsx = (
    <div className="pod-progress-bar mt-4">
      <Progress className="progress-xl pod-progress-bar__track" multi>
        <Progress striped animated bar color="info" className="pod-progress-bar__segment pod-progress-bar__segment--progress" value={progressPercent}>
          <span className="fs-5 pod-progress-bar__value">{`${progressPercent.toString()}%`}</span>
        </Progress>
        <Progress striped bar color="danger" className="pod-progress-bar__segment pod-progress-bar__segment--expected" value={gapPercent}>
          <span className="fs-5 pod-progress-bar__value">{`${expectedPercent.toString()}%`}</span>
        </Progress>
      </Progress>
      <div className="pod-progress-bar__label text-center mt-2">
        <span className="fs-5">{label}</span>
      </div>
    </div>
  );

  return jsx;
}

PodProgressBar.defaultProps = {
  t: () => {},
  goal: 100,
  progress: 0,
  expected: 0,
  label: 'Test',
};

PodProgressBar.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  goal: PropTypes.number,
  progress: PropTypes.number,
  expected: PropTypes.number,
  label: PropTypes.string,
};

export default connect(() => ({

}), {})(withTranslation()(PodProgressBar));
